/* Custom product info — "Personalise Your Pair" modal behaviour.

   Opens from the personalise button, toggles captain-enabled placement cards
   (Remove <-> Add), locks options the captain didn't enable, handles the
   Front/Back preview switch and the initials choice, and on Save writes the
   selections into the cart form as line-item properties.

   Registers itself on the shared `window.CPI.inits` list defined in cpi.js. */
window.CPI = window.CPI || { inits: [] };
(function (CPI) {
  function initModal(root) {
    var modal = root.querySelector('[data-cpi-modal]');
    if (!modal) return;

    // Relocate the modal to <body> so its fixed overlay covers the whole
    // viewport. Left inside the section, a transformed/contained theme
    // ancestor traps `position: fixed` and the backdrop fails to dim the page.
    var owner = root.id;
    if (owner && modal.parentNode !== document.body) {
      Array.prototype.slice.call(document.body.children).forEach(function (ch) {
        if (ch !== modal && ch.classList && ch.classList.contains('cpi-modal') && ch.getAttribute('data-cpi-owner') === owner) {
          ch.parentNode.removeChild(ch); // clear a stale copy from a prior editor reload
        }
      });
      modal.setAttribute('data-cpi-owner', owner);
      document.body.appendChild(modal);
    }

    var openBtn = root.querySelector('[data-cpi-personalise]');
    var label = root.querySelector('[data-cpi-personalise-label]');
    var summary = root.querySelector('[data-cpi-personalise-summary]');
    var propsHost = root.querySelector('[data-cpi-props]');
    var places = Array.prototype.slice.call(modal.querySelectorAll('[data-place]'));
    var initialsBox = modal.querySelector('[data-cpi-initials]');
    var initialsInput = modal.querySelector('[data-cpi-initials-input]');
    var saveBtn = modal.querySelector('[data-cpi-save]');
    var initialsDefault = '';
    var snapshot = null;

    // Variant resolution: map the buyer's choices to the matching Shopify variant
    // so Add to cart / Buy submit the right one.
    var idInput = root.querySelector('[data-cpi-id]');
    var atcBtn = root.querySelector('[data-cpi-atc]');
    var priceEl = root.querySelector('[data-cpi-price]');
    var moneyFormat = root.getAttribute('data-cpi-money-format') || '{{amount}}';
    var variantData = [];
    var optionNames = [];
    (function () {
      var vEl = root.querySelector('[data-cpi-variants]');
      var nEl = root.querySelector('[data-cpi-option-names]');
      try { if (vEl) variantData = JSON.parse(vEl.textContent); } catch (e) {}
      try {
        if (nEl) {
          // Accept either ["Name", …] or [{name:"…"}, …] and normalise to names.
          optionNames = JSON.parse(nEl.textContent).map(function (o) {
            return o && typeof o === 'object' ? o.name : o;
          });
        }
      } catch (e) {}
    })();

    function formatMoney(cents) {
      var v = cents / 100;
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, v.toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(v)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(v)));
    }

    // The option value each toggle currently maps to, keyed by variant option name.
    function chosenOptionValues() {
      var map = {};
      places.forEach(function (el) {
        var name = el.getAttribute('data-opt-name');
        if (!name) return;
        map[name] = isSelected(el) ? el.getAttribute('data-val-on') : el.getAttribute('data-val-off');
      });
      if (initialsBox && initialsBox.getAttribute('data-opt-name')) {
        map[initialsBox.getAttribute('data-opt-name')] =
          isSelected(initialsBox) ? initialsBox.getAttribute('data-val-on') : initialsBox.getAttribute('data-val-off');
      }
      return map;
    }

    // Point the cart form at the variant matching the current choices.
    function resolveVariant() {
      if (!idInput || !variantData.length || !optionNames.length) return;
      var chosen = chosenOptionValues();
      var target = optionNames.map(function (n) { return chosen[n]; });
      if (target.some(function (t) { return t == null; })) {
        if (window.console) console.warn('[CPI] variant not resolved — options:', optionNames, 'chosen:', chosen);
        return; // not all options driven by the modal
      }
      var match = variantData.filter(function (v) {
        var opts = v.options || [];
        return opts.length === target.length && opts.every(function (val, i) { return val === target[i]; });
      })[0];
      if (!match) {
        if (window.console) console.warn('[CPI] no variant matches', target);
        return;
      }
      idInput.value = match.id;
      if (atcBtn) {
        if (match.available === false) { atcBtn.disabled = true; atcBtn.textContent = 'Sold out'; }
        else { atcBtn.disabled = false; atcBtn.textContent = 'Add to cart'; }
      }
      if (priceEl && typeof match.price === 'number') priceEl.textContent = formatMoney(match.price);
    }

    function isSelected(el) { return el.getAttribute('data-selected') === 'true'; }
    function isEnabled(el) { return el.getAttribute('data-enabled') === 'true'; }

    /* Map each placement id -> the acronym/initials mark(s) baked into the
       preview SVG, so removing a card hides the real mark on the product image.
       Prefers explicit data-cpi-place tags (set by the kit generator); falls
       back to classifying the SVG's <text> nodes for products generated before
       tagging existed. */
    var placeMarks = {};
    function registerMark(id, el) {
      if (!id || !el) return;
      (placeMarks[id] = placeMarks[id] || []).push(el);
    }
    function classifyText(t, side) {
      if (t.querySelector && t.querySelector('textPath')) return 'on_bum'; // bum acronym rides a curve
      var tr = t.getAttribute('transform') || '';
      if (/rotate/i.test(tr)) return side === 'back' ? 'back_leg' : 'side_leg'; // leg acronym is rotated
      if (side === 'front') return 'initials'; // remaining front text is the initials mark
      return null; // leave unidentified back text (e.g. a back design) untouched
    }
    function registerView(view, side) {
      var tagged = view.querySelectorAll('[data-cpi-place]');
      if (tagged.length) {
        Array.prototype.slice.call(tagged).forEach(function (el) { registerMark(el.getAttribute('data-cpi-place'), el); });
      } else {
        Array.prototype.slice.call(view.querySelectorAll('text')).forEach(function (t) { registerMark(classifyText(t, side), t); });
      }
    }
    Array.prototype.slice.call(modal.querySelectorAll('[data-cpi-stage]')).forEach(function (view) {
      registerView(view, view.getAttribute('data-cpi-stage'));
    });

    /* Live PDP gallery preview. Burned-photo galleries stash the vector
       previews in <template> tags (cpi-gallery.liquid). Mount one hidden copy
       inside every burned slide — carousel loop clones included — and register
       its marks in the SAME registry, so every toggle and typed initial the
       buyer makes in the modal updates the gallery copy in lockstep. On Save,
       updateGallery() swaps burned photo <-> live preview whenever the saved
       state differs from the captain's default (which is what the burned
       composite depicts). */
    var gallery = root.querySelector('.cpi__gallery');
    var hasGalleryPreview = false;
    if (gallery) {
      ['front', 'back'].forEach(function (side) {
        var tpl = gallery.querySelector('template[data-cpi-live-template="' + side + '"]');
        if (!tpl || !tpl.content || !tpl.content.firstElementChild) return;
        Array.prototype.slice.call(gallery.querySelectorAll('.cpi__slide[data-cpi-burned="' + side + '"]')).forEach(function (slide) {
          var burned = slide.querySelector('.cpi__media');
          if (!burned) return;
          var live = tpl.content.firstElementChild.cloneNode(true);
          live.setAttribute('data-cpi-live-media', side);
          live.hidden = true;
          burned.setAttribute('data-cpi-burned-media', side);
          slide.appendChild(live);
          registerView(live, side);
          hasGalleryPreview = true;
        });
      });
    }
    function setMark(id, on) {
      var els = placeMarks[id];
      if (!els) return;
      els.forEach(function (el) { el.classList.toggle('is-hidden', !on); });
    }

    // The captain's default selections, as rendered — the state the burned
    // gallery composites depict. Any saved deviation switches the gallery to
    // the live preview; saving back to exactly this state restores the photos.
    var galleryDefaults = {
      places: places.map(function (el) { return el.getAttribute('data-selected') === 'true'; }),
      initials: initialsBox ? initialsBox.getAttribute('data-selected') === 'true' : false
    };
    function isCustomized() {
      var changed = places.some(function (el, i) { return isSelected(el) !== galleryDefaults.places[i]; });
      var initOn = initialsBox ? isSelected(initialsBox) : false;
      if (initOn !== galleryDefaults.initials) changed = true;
      if (initOn && initialsValue()) changed = true; // typed initials replace the burned placeholder
      return changed;
    }
    function updateGallery() {
      if (!hasGalleryPreview) return;
      var on = isCustomized();
      Array.prototype.slice.call(gallery.querySelectorAll('[data-cpi-burned-media]')).forEach(function (el) { el.hidden = on; });
      Array.prototype.slice.call(gallery.querySelectorAll('[data-cpi-live-media]')).forEach(function (el) { el.hidden = !on; });
      // Bring the (front) preview into view so the buyer sees their change land.
      if (on && typeof root.cpiGoTo === 'function') root.cpiGoTo(0);
    }

    // Remember the acronym baked into the initials mark so we can fall back to it
    // before the buyer has typed anything.
    if (placeMarks.initials && placeMarks.initials[0]) initialsDefault = placeMarks.initials[0].textContent;
    function initialsValue() {
      return initialsInput ? (initialsInput.value || '').trim().toUpperCase() : '';
    }
    function updateInitialsText() {
      var val = initialsValue() || initialsDefault;
      (placeMarks.initials || []).forEach(function (el) { el.textContent = val; });
    }

    // Show the requested preview side and sync the Front/Back toggle.
    function showSide(side) {
      modal.querySelectorAll('[data-cpi-side]').forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-cpi-side') === side);
      });
      modal.querySelectorAll('[data-cpi-stage]').forEach(function (v) {
        v.hidden = v.getAttribute('data-cpi-stage') !== side;
      });
    }

    function setPlace(el, sel) {
      if (!isEnabled(el)) return; // captain didn't enable this — locked
      el.setAttribute('data-selected', sel ? 'true' : 'false');
      el.classList.toggle('is-selected', !!sel);
      var btn = el.querySelector('[data-place-toggle]');
      if (btn) btn.textContent = sel ? 'Remove' : 'Add';
      setMark(el.getAttribute('data-id'), sel); // hide/show the mark on the product image in real time
    }
    function setInitials(yes) {
      if (!initialsBox) return;
      initialsBox.setAttribute('data-selected', yes ? 'true' : 'false');
      initialsBox.querySelectorAll('[data-init]').forEach(function (b) {
        var on = (b.getAttribute('data-init') === 'yes') === yes;
        b.classList.toggle('is-active', on);
      });
      if (initialsInput) initialsInput.hidden = !yes; // reveal the text field on "Yes"
      setMark('initials', yes);
      if (yes) updateInitialsText();
    }
    // Bring the preview into line with the cards' initial state (e.g. hide the
    // initials mark when the card defaults to "No thanks").
    function syncMarks() {
      places.forEach(function (el) { setMark(el.getAttribute('data-id'), isSelected(el)); });
      if (initialsBox) setMark('initials', isSelected(initialsBox));
    }

    function takeSnapshot() {
      snapshot = {
        places: places.map(isSelected),
        initials: initialsBox ? isSelected(initialsBox) : false,
        initialsText: initialsInput ? initialsInput.value : ''
      };
    }
    function restore() {
      if (!snapshot) return;
      places.forEach(function (el, i) { setPlace(el, snapshot.places[i]); });
      if (initialsInput) initialsInput.value = snapshot.initialsText;
      if (initialsBox) setInitials(snapshot.initials);
      updateInitialsText();
    }

    function open() { takeSnapshot(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }

    function selectedPlaces() {
      return places.filter(function (el) { return isEnabled(el) && isSelected(el); });
    }
    function addProp(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      i.value = value;
      propsHost.appendChild(i);
    }
    function commit() {
      var initialsOn = initialsBox && isSelected(initialsBox);
      var iv = initialsValue();
      if (propsHost) {
        propsHost.innerHTML = '';
        var names = selectedPlaces().map(function (el) { return el.getAttribute('data-name'); });
        if (names.length) addProp('Acronym Placement', names.join(', '));
        if (initialsOn) addProp('Initials', iv || 'Yes');
      }
      resolveVariant(); // point the cart form at the variant matching these choices
      updateGallery(); // burned photos <-> live preview, per the saved choices
      var count = selectedPlaces().length + (initialsOn ? 1 : 0);
      if (label) label.textContent = count > 0 ? 'Edit Personalisation' : 'Personalisation';
      if (summary) {
        var parts = selectedPlaces().map(function (el) { return el.getAttribute('data-name'); });
        if (initialsOn) parts.push(iv ? 'Initials: ' + iv : 'Initials');
        if (parts.length) { summary.textContent = parts.join(' · '); summary.hidden = false; }
        else { summary.textContent = ''; summary.hidden = true; }
      }
    }

    if (openBtn) {
      openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    }
    modal.querySelectorAll('[data-cpi-close]').forEach(function (b) {
      b.addEventListener('click', function () { restore(); close(); });
    });
    modal.querySelectorAll('[data-cpi-side]').forEach(function (b) {
      b.addEventListener('click', function () { showSide(b.getAttribute('data-cpi-side')); });
    });
    places.forEach(function (el) {
      var btn = el.querySelector('[data-place-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        setPlace(el, !isSelected(el));
        showSide(el.getAttribute('data-side') || 'front'); // jump to the side that just changed
      });
    });
    if (initialsBox) {
      initialsBox.querySelectorAll('[data-init]').forEach(function (b) {
        b.addEventListener('click', function () {
          var yes = b.getAttribute('data-init') === 'yes';
          setInitials(yes);
          showSide(initialsBox.getAttribute('data-side') || 'front'); // initials sit on the front
          if (yes && initialsInput) { try { initialsInput.focus(); } catch (e) {} }
        });
      });
    }
    if (initialsInput) {
      initialsInput.addEventListener('input', updateInitialsText); // live-update the mark as they type
    }
    if (saveBtn) {
      saveBtn.addEventListener('click', function () { commit(); close(); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) { restore(); close(); }
    });

    syncMarks(); // preview must match the cards before the modal is ever opened
    resolveVariant(); // align the cart form's variant with the default selections
  }

  CPI.inits.push(initModal);
})(window.CPI);
